import { useContext } from 'react';
import { NetworkErrorContext } from '../../layouts/NetworkError';

export const useNetworkErrorState = () => {
  const networkErrorState = useContext(NetworkErrorContext);

  return {
    isNetworkError: networkErrorState.networkError,
    setNetworkErrorState: networkErrorState.setNetworkError
  };
};
